module.exports = __webpack_public_path__ + "static/media/IMG_2869.fd0963ed.jpg";